import { makeAutoObservable } from 'mobx'
import type { ISurveyCommonData } from 'entities/Surveys/model/types'
import { type IResponseFullSurvey, type SurveysStatus } from 'entities/Surveys/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class SurveyFull {
  id: IResponseFullSurvey['id']
  name: IResponseFullSurvey['name']
  status: IResponseFullSurvey['status']
  total_sent: IResponseFullSurvey['total_contacts_count'] = 0
  valid_replies: IResponseFullSurvey['valid_replies_count'] = 0
  invalid_replies: IResponseFullSurvey['invalid_replies_count'] = 0
  undelivered: IResponseFullSurvey['undelivered_count'] = 0
  expired: IResponseFullSurvey['expired_count'] = 0
  nps_score: IResponseFullSurvey['nps_score'] = 0
  created_at: IResponseFullSurvey['created_at'] = ''
  send_from: IResponseFullSurvey['send_from'] | null = null

  constructor(response: IResponseFullSurvey, private _entities: IEntitiesStore) {
    this.id = response.id
    this.name = response.name
    this.status = response.status
    this.total_sent = response.total_contacts_count
    this.valid_replies = response.valid_replies_count
    this.invalid_replies = response.invalid_replies_count
    this.undelivered = response.undelivered_count
    this.expired = response.expired_count
    this.nps_score = response.nps_score
    this.created_at = response.created_at
    this.send_from = response.send_from

    makeAutoObservable(this)
  }

  syncOrigin = (response: IResponseFullSurvey) => {
    this.name = response.name
    this.status = response.status
    this.total_sent = response.total_contacts_count
    this.valid_replies = response.valid_replies_count
    this.invalid_replies = response.invalid_replies_count
    this.undelivered = response.undelivered_count
    this.expired = response.expired_count
    this.nps_score = response.nps_score
    this.created_at = response.created_at
    this.send_from = response.send_from
  }

  get data(): ISurveyCommonData {
    return {
      id: this.id,
      name: this.name,
      status: this.status,
    }
  }

  get inboxId() {
    if (this.send_from?.type === 'from_contact_owner') return

    if (this.send_from?.options.team_id) {
      const inbox = this._entities.inboxesStore.getItem(this.send_from?.options.team_id)

      return inbox?.id
    }

    if (this.send_from?.options.number_id) {
      const inbox = this._entities.inboxesStore.getInboxByNumber(this.send_from?.options.number_id)

      return inbox?.id
    }
  }

  setStatus = (value: SurveysStatus) => {
    this.status = value
  }
}
